import type { ToastItem, ToastType } from './components/portal-toast/portal-toast.js'
import { createToast } from './components/portal-toast/portal-toast.js'

type Listener = (toast: ToastItem) => void

let listeners: Listener[] = []

export const showToast = (message: string, type: ToastType = 'info') => {
    const toast = createToast(message, type)
    listeners.forEach((l) => l(toast))
}

export const subscribeToToasts = (listener: Listener): (() => void) => {
    listeners = [...listeners, listener]
    return () => {
        listeners = listeners.filter((l) => l !== listener)
    }
}
